import { useReactiveVar } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { attetionModalVar } from "../../../graphql/globalVar/state";
import { useEventActions } from "../../../hooks/useEventActions";
import useGetUrlLocale from "../../../hooks/useGetUrlLocale";

function AttetionModal() {
  const eventId = useReactiveVar(attetionModalVar);
  const { t } = useTranslation();
  const locale = useGetUrlLocale();
  const { publishEvent, publishLoading } = useEventActions();
  const [termsAccepted, setTermsAccepted] = useState(false);

  const policyBaseUrl = `${process.env.REACT_APP_TICKET_URL}${locale}`;

  useEffect(() => {
    setTermsAccepted(false);
  }, [eventId]);

  const handleHide = () => {
    attetionModalVar(null);
    setTermsAccepted(false);
  };

  return (
    <Modal
      show={eventId !== null}
      onHide={handleHide}
      centered
      dialogClassName="modal-stop-tickets-sale"
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 p-3">
        <Modal.Title className="fw-bold">
          {t("events.modals.attention.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center text-muted p-3 px-4 fs-6">
        <p className="fs-6 text-dark m-0 px-1 px-md-0">
          <Trans
            i18nKey="events.modals.attention.body"
            components={{
              1: (
                <a
                  href={`${policyBaseUrl}/terms-and-conditions`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-success text-decoration-underline"
                />
              ),
            }}
          />
        </p>
        <Form.Check
          type="checkbox"
          id="attention-terms-checkbox"
          className="text-start mt-3 fs-6"
          checked={termsAccepted}
          onChange={(e) => setTermsAccepted(e.target.checked)}
          label={
            <Trans
              i18nKey="events.modals.attention.agreeToTerms"
              components={{
                terms: (
                  <a
                    href={`${policyBaseUrl}/terms-and-conditions`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-success"
                  />
                ),
                refund: (
                  <a
                    href={`${policyBaseUrl}/refunds-and-exchanges`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-success"
                  />
                ),
                privacy: (
                  <a
                    href={`${policyBaseUrl}/privacy-policy`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-success"
                  />
                ),
              }}
            />
          }
        />
      </Modal.Body>
      <Modal.Footer className="border-0 w-100 pt-0">
        <Row className="g-2 w-100 m-0">
          <Col xs={4} md={6}>
            <Link
              to={`${locale}/create-event/${eventId}/edit`}
              className="btn btn-outline-dark w-100 py-3 rounded-3 fw-normal"
              onClick={handleHide}
            >
              {t("events.modals.attention.editInfo")}
            </Link>
          </Col>
          <Col xs={8} md={6}>
            <Button
              variant="success"
              className="w-100 py-3 rounded-3 text-white"
              onClick={() => eventId && publishEvent(eventId)}
              disabled={!termsAccepted || publishLoading}
            >
              {publishLoading
                ? t("events.modals.attention.publishing")
                : t("events.modals.attention.postToCatalog")}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default AttetionModal;
